export const expEn = {
  'dat.exp.eyebrow': 'Catalogue',
  'dat.exp.title': 'Export records',
  'dat.exp.description': 'Download bibliographic records, with or without their items, for other systems or for backup.',
  'dat.exp.format.title': 'Format',
  'dat.exp.format.marcxml': 'MARCXML',
  'dat.exp.format.marcxmlHint': 'Readable XML. Best for most migrations.',
  'dat.exp.format.iso2709': 'ISO 2709',
  'dat.exp.format.iso2709Hint': 'Binary MARC (.mrc) used by older systems.',
  'dat.exp.format.csv': 'CSV',
  'dat.exp.format.csvHint': 'A spreadsheet with one row per item.',
  'dat.exp.filters.title': 'What to export',
  'dat.exp.filters.description': 'Leave everything empty to export the whole catalogue.',
  'dat.exp.idFrom': 'Record id from',
  'dat.exp.idTo': 'Record id to',
  'dat.exp.ids': 'Specific record ids',
  'dat.exp.idsHint': 'Separate with commas or spaces. Combined with the other filters.',
  'dat.exp.itemType': 'Item type',
  'dat.exp.anyItemType': 'Any item type',
  'dat.exp.library': 'Library',
  'dat.exp.libraryHint': 'Records with an item at this library.',
  'dat.exp.anyLibrary': 'Any library',
  'dat.exp.updatedSince': 'Changed since',
  'dat.exp.includeItems': 'Include items',
  'dat.exp.includeItemsHint': 'Barcodes, call numbers and locations (952 fields).',
  'dat.exp.summary.title': 'Your export',
  'dat.exp.summary.lead': 'A {format} file of',
  'dat.exp.summary.all': 'every record in the catalogue.',
  'dat.exp.summary.filtered': 'the records that match:',
  'dat.exp.summary.withItems': 'Items are included.',
  'dat.exp.summary.noItems': 'Items are left out.',
  'dat.exp.desc.ids': '{count} specific records',
  'dat.exp.desc.range': 'Record ids {from} to {to}',
  'dat.exp.desc.from': 'Record id {from} and above',
  'dat.exp.desc.to': 'Record id {to} and below',
  'dat.exp.desc.itemType': 'Item type: {name}',
  'dat.exp.desc.library': 'Library: {name}',
  'dat.exp.desc.since': 'Changed on or after {date}',
  'dat.exp.err.ID_FROM': 'Enter a whole number greater than zero.',
  'dat.exp.err.ID_TO': 'Enter a whole number greater than zero.',
  'dat.exp.err.ID_RANGE': 'The first id must not be larger than the last.',
  'dat.exp.err.IDS_FORMAT': 'Use whole numbers separated by commas or spaces.',
  'dat.exp.err.IDS_TOO_MANY': 'You can list at most 5000 ids.',
  'dat.exp.err.DATE_FORMAT': 'Pick a valid date.',
  'dat.exp.err.DATE_FUTURE': 'That date is in the future.',
  'dat.exp.submit': 'Download export',
  'dat.exp.preparing': 'Preparing your file',
  'dat.exp.cancel': 'Cancel',
  'dat.exp.cancelled': 'Export cancelled.',
  'dat.exp.done': 'Export downloaded',
  'dat.exp.doneDetail': '{name} ({size}) was saved to your downloads.',
  'dat.exp.failed': 'The export did not finish',
  'dat.exp.badFilters': 'The server did not accept these filters. Check the ids and the date.',
  'dat.exp.empty': 'No records matched',
  'dat.exp.emptyHint': 'The file would be empty, so nothing was downloaded. Loosen the filters and try again.',
  'dat.exp.remembered': 'Your last settings are remembered on this device.',
} as const;

export const expHi: Record<keyof typeof expEn, string> = {
  'dat.exp.eyebrow': 'सूची',
  'dat.exp.title': 'रिकॉर्ड निर्यात करें',
  'dat.exp.description': 'अन्य प्रणालियों या बैकअप के लिए ग्रंथसूची रिकॉर्ड, आइटम सहित या रहित, डाउनलोड करें।',
  'dat.exp.format.title': 'प्रारूप',
  'dat.exp.format.marcxml': 'MARCXML',
  'dat.exp.format.marcxmlHint': 'पढ़ने योग्य XML। अधिकांश माइग्रेशन के लिए सबसे अच्छा।',
  'dat.exp.format.iso2709': 'ISO 2709',
  'dat.exp.format.iso2709Hint': 'पुरानी प्रणालियों में उपयोग होने वाला बाइनरी MARC (.mrc)।',
  'dat.exp.format.csv': 'CSV',
  'dat.exp.format.csvHint': 'प्रति आइटम एक पंक्ति वाली स्प्रेडशीट।',
  'dat.exp.filters.title': 'क्या निर्यात करना है',
  'dat.exp.filters.description': 'पूरी सूची निर्यात करने के लिए सब खाली छोड़ें।',
  'dat.exp.idFrom': 'रिकॉर्ड आईडी से',
  'dat.exp.idTo': 'रिकॉर्ड आईडी तक',
  'dat.exp.ids': 'विशिष्ट रिकॉर्ड आईडी',
  'dat.exp.idsHint': 'अल्पविराम या स्पेस से अलग करें। अन्य फ़िल्टर के साथ जुड़ता है।',
  'dat.exp.itemType': 'आइटम प्रकार',
  'dat.exp.anyItemType': 'कोई भी आइटम प्रकार',
  'dat.exp.library': 'पुस्तकालय',
  'dat.exp.libraryHint': 'इस पुस्तकालय में आइटम वाले रिकॉर्ड।',
  'dat.exp.anyLibrary': 'कोई भी पुस्तकालय',
  'dat.exp.updatedSince': 'इसके बाद बदले',
  'dat.exp.includeItems': 'आइटम शामिल करें',
  'dat.exp.includeItemsHint': 'बारकोड, कॉल नंबर और स्थान (952 फ़ील्ड)।',
  'dat.exp.summary.title': 'आपका निर्यात',
  'dat.exp.summary.lead': '{format} फ़ाइल जिसमें',
  'dat.exp.summary.all': 'सूची का हर रिकॉर्ड होगा।',
  'dat.exp.summary.filtered': 'वे रिकॉर्ड होंगे जो इनसे मेल खाते हैं:',
  'dat.exp.summary.withItems': 'आइटम शामिल हैं।',
  'dat.exp.summary.noItems': 'आइटम छोड़े गए हैं।',
  'dat.exp.desc.ids': '{count} विशिष्ट रिकॉर्ड',
  'dat.exp.desc.range': 'रिकॉर्ड आईडी {from} से {to}',
  'dat.exp.desc.from': 'रिकॉर्ड आईडी {from} और उससे ऊपर',
  'dat.exp.desc.to': 'रिकॉर्ड आईडी {to} और उससे नीचे',
  'dat.exp.desc.itemType': 'आइटम प्रकार: {name}',
  'dat.exp.desc.library': 'पुस्तकालय: {name}',
  'dat.exp.desc.since': '{date} या उसके बाद बदले',
  'dat.exp.err.ID_FROM': 'शून्य से बड़ी पूर्ण संख्या दर्ज करें।',
  'dat.exp.err.ID_TO': 'शून्य से बड़ी पूर्ण संख्या दर्ज करें।',
  'dat.exp.err.ID_RANGE': 'पहली आईडी अंतिम से बड़ी नहीं होनी चाहिए।',
  'dat.exp.err.IDS_FORMAT': 'अल्पविराम या स्पेस से अलग की गई पूर्ण संख्याएँ उपयोग करें।',
  'dat.exp.err.IDS_TOO_MANY': 'अधिकतम 5000 आईडी सूचीबद्ध की जा सकती हैं।',
  'dat.exp.err.DATE_FORMAT': 'मान्य तारीख चुनें।',
  'dat.exp.err.DATE_FUTURE': 'वह तारीख भविष्य में है।',
  'dat.exp.submit': 'निर्यात डाउनलोड करें',
  'dat.exp.preparing': 'आपकी फ़ाइल तैयार हो रही है',
  'dat.exp.cancel': 'रद्द करें',
  'dat.exp.cancelled': 'निर्यात रद्द किया गया।',
  'dat.exp.done': 'निर्यात डाउनलोड हो गया',
  'dat.exp.doneDetail': '{name} ({size}) आपके डाउनलोड में सहेजी गई।',
  'dat.exp.failed': 'निर्यात पूरा नहीं हुआ',
  'dat.exp.badFilters': 'सर्वर ने ये फ़िल्टर स्वीकार नहीं किए। आईडी और तारीख जाँचें।',
  'dat.exp.empty': 'कोई रिकॉर्ड मेल नहीं खाया',
  'dat.exp.emptyHint': 'फ़ाइल खाली होती, इसलिए कुछ डाउनलोड नहीं हुआ। फ़िल्टर ढीले करके फिर कोशिश करें।',
  'dat.exp.remembered': 'आपकी पिछली सेटिंग इस डिवाइस पर याद रखी जाती हैं।',
};
